import React from 'react';
import {apiRoutePrefix, RouteComponent} from '../../../RouteComponent';
import {Box, Divider} from '@material-ui/core';
import ObjectHeader from '../ObjectHeader';
import ObjectDefinition from '../ObjectDefinition';
import RequestDefinition from '../RequestDefinition';
import {jsonObject, uomAttributes, uomsHeader} from '../../data/uom/uoms';

export default new RouteComponent(`${apiRoutePrefix}/uoms`, () => {
    return (
        <div>
            <ObjectHeader data={ uomsHeader }/>

            <Box mb={ 3 }>
                <Divider/>
            </Box>

            <ObjectDefinition data={ {
                title: 'The UOM object',
                attributes: uomAttributes,
                jsonObject: jsonObject
            } }/>
            {
                uomsHeader.endpoints.map(request => (
                    <>
                        <Box mb={3}>
                            <Divider/>
                        </Box>
                        <RequestDefinition {...request}/>
                    </>
                ))
            }
        </div>
    );
});
